module.exports = __webpack_public_path__ + "static/assets/b79526d7b424da1546480d23671861c7.gif";